export const createFiltersString = (initialValue = '') => {
    let value = initialValue;
    return {
        add: (filter, operator = 'AND') => {
            value += value.length > 0 ? ` ${operator} ${filter}` : filter;
        },
        value: () => value
    };
};
